import { Role } from './role';

export class User {
  dataset: {
    roles?: string;
    avatar?:string;
    caducidad?:Date;
    modo?: String;
  }
  id: number;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  avatar: string;
  list: string;
  status: string;
  role: Role;
  token?: string;
}
